<div class="modal-header">
    <h4 class="modal-title"> Cihaz Ekle</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body col-12">
    <form [formGroup]="deviceForm">
        <div class="row">
            <!-- Firma Seçimi -->
            <div class="col-xl-4 col-md-6 col-sm-12 col-12">
                <label for="companyId">Firma</label>
                <ng-select [items]="companies" bindLabel="companyName" bindValue="id"
                    formControlName="companyId"></ng-select>
                <div *ngIf="deviceForm.get('companyId').invalid && deviceForm.get('companyId').touched"
                    class="text-danger">
                    Firma zorunludur.
                </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="companyPersonId">Firma Yetkili Kişi</label>
                <div class="form-group">
                    <ng-select [bindValue]="'id'" formControlName="companyPersonId">
                        <ng-option *ngFor="let user of companyPersons" [value]="user.id">{{user.name + ' ' +
                            user.lastName}}</ng-option>
                    </ng-select>
                    <div *ngIf="deviceForm.get('companyPersonId').invalid && deviceForm.get('companyPersonId').touched"
                        class="text-danger">
                        Cihaz Yetkili Kişisi Zorunludur.
                    </div>
                </div>
            </div>
        </div>

        <!-- Ürünler -->
        <div formArrayName="createDevicesList">
            <div *ngFor="let product of createDevicesList.controls; let i = index" [formGroupName]="i" class="row mt-2">
                <div class="col-xl-2 col-md-6 col-sm-12 col-12">
                    <label for="kindId">Cihaz Türü</label>
                    <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" formControlName="kindId"></ng-select>
                </div>

                <div class="col-xl-3 col-md-5 col-sm-11 col-12">
                    <label for="brandModalId">Marka & Model</label>
                    <div class="form-group">
                        <ng-select [items]="brands" [searchFn]="searchFn" bindLabel="name" bindValue="id" groupBy="brandName" formControlName="brandModelId">
                            <ng-template ng-optgroup-tmp let-item="item">
                                {{ item.brandName || 'Bilinmeyen Marka' }}
                            </ng-template>
                        </ng-select>
                        <div *ngIf="deviceForm.get('brandModalId')?.invalid && deviceForm.get('brandModalId')?.touched"
                            class="text-danger">
                            Model seçmek zorunludur.
                        </div>
                    </div>
                </div>

                <div class="col-xl-1 col-md-1 col-sm-2 col-12 mt-2">
                    <button type="button" class="btn btn-icon btn-flat-warning" (click)="onCreateBrandModel()" rippleEffect>
                        <span [data-feather]="'plus'"></span>
                    </button>
                </div>

                <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                    <label for="seriNo">Seri No</label>
                    <input type="text" class="form-control" formControlName="seriNo" maxlength="30" />
                </div>

                <div class="col-xl-2 col-md-6 col-sm-12 col-12">
                    <label for="period">Period(Ay)</label>
                    <input type="number" class="form-control" formControlName="period" />
                </div>

                <div class="col-xl-1 col-md-1 col-sm-12 col-12 mt-2">
                    <button type="button" class="btn btn-icon btn-flat-danger" (click)="removeProduct(i)" rippleEffect>
                        <span [data-feather]="'trash'"></span>
                    </button>
                </div>

                <div class="col-xl-12 col-md-12 col-sm-12 col-12 mt-2">
                    <label for="basicTextarea">Açıklama</label>
                    <fieldset class="form-group">
                      <textarea class="form-control" id="basicTextarea" rows="1" placeholder="Cihaz açıklaması" formControlName="description"></textarea>
                    </fieldset>
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-primary mt-2" (click)="addProduct()">+</button>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Hayır</button>
    <button type="button" class="btn btn-success" [disabled]="!deviceForm.valid" (click)="onSumbit()">Kaydet</button>
</div>